export const CRM_CONFIG = {
  sheetId: '13hkrXyz-8CFLACby7AzN7yW8-OSSfAotJJbEAxZ5xvI',
  sheetUrl:
    'https://docs.google.com/spreadsheets/d/13hkrXyz-8CFLACby7AzN7yW8-OSSfAotJJbEAxZ5xvI/edit?usp=sharing',
  workbookName: 'CRM William',
  sheetTimeZone: 'America/Los_Angeles',
  sheets: {
    organizations: { name: 'Organizations', gid: '1014948252' },
    opportunities: { name: 'Opportunities', gid: '2033551765' },
  },
} as const

export const PROSPECTING_CONFIG = {
  sheetId: '1ni6kl0f-lZG_z4oXgKg92AQ6jWGLw-r5C87QPfoJNrc',
  workbookName: 'William CRM',
  sheets: {
    audit: { name: 'Audit', gid: '700939867' },
    leads: { name: 'Leads', gid: '780722160' },
    old: { name: 'Old Leads', gid: '233948746' },
    hot: { name: 'Hot', gid: '313788357' },
    platinum: { name: 'Platinum Options', gid: '574965847' },
  },
} as const
